import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Snackbar, Alert } from "@mui/material";
import "./AlumniForm.css";

export default function AlumniForm() {
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const colleges = [
    "Aditya University",
    "Aditya Engineering College (Campus - 1)",
    "Aditya College of Engineering and Technology (Campus - 2)",
    "Aditya College Of Engineering (Campus - 3)",
    "Aditya Polytechnic Colleges",
    "Aditya Pharmacy Colleges",
    "Aditya Business Schools",
    "Others",
  ];

  const defaultProgramBranches = {
    "B.Tech": [
      "Computer Science and Engineering (CSE)",
      "Electronics and Communication Engineering (ECE)",
      "Electrical and Electronics Engineering (EEE)",
      "Mechanical Engineering (ME)",
      "Civil Engineering (CE)",
      "Information Technology (IT)",
      "Artificial Intelligence and Machine Learning (AIML)",
      "Data Science (DS)",
      "Agricultural Engineering (Ag.E)",
      "Mining Engineering (Min.E)",
      "Petroleum Technology (PET)",
      "Internet of Things (IoT)",
      "Other",
    ],
    "M.Tech": [
      "Computer Science and Engineering (CSE)",
      "VLSI Design",
      "Power Electronics and Drives",
      "Structural Engineering",
      "Thermal Engineering",
      "Embedded Systems",
      "Energy Science and Technology",
      "CSE (AI & ML)",
      "Artificial Intelligence and Data Science",
      "Petroleum Engineering",
      "Software Engineering",
      "Other",
    ],
    "Diploma": [
      "Civil Engineering (CE)",
      "Electrical and Electronics Engineering (EEE)",
      "Mechanical Engineering (ME)",
      "Electronics and Communication Engineering (ECE)",
      "Computer Science and Engineering (CSE)",
      "Petroleum Technology (PET)",
      "Mining Engineering (Min.E)",
      "Communication & Computer Networking",
      "Other",
    ],
    "MBA/IMBA": [
      "MBA",
      "MBA (Business Analytics)",
      "MBA (Finance)",
      "MBA (Human Resource Management)",
      "MBA (Marketing)",
      "MBA (Global Finance)",
      "MBA (FinTech)",
      "MBA (Health Care Management)",
      "MBA for Working Professionals",
      "IMBA (Integrated MBA)",
      "BBA",
      "BBA (Business Analytics)",
      "BBA (Digital Marketing)",
      "Other",
    ],
    "MCA": ["MCA", "Other"],
    "Ph.D": [
      "Computer Science and Engineering",
      "Electronics and Communication Engineering",
      "Electrical and Electronics Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Agricultural Engineering",
      "Mining Engineering",
      "Petroleum Technology",
      "Management Studies",
      "Mathematics",
      "Physics",
      "Chemistry",
      "English",
      "Pharmaceutical Sciences",
      "Other",
    ],
    "B.Pharmacy": ["B.Pharmacy", "Other"],
    "M.Pharmacy": [
      "Pharmaceutics",
      "Pharmaceutical Analysis",
      "Pharmacology",
      "Regulatory Affairs",
      "Pharmacognosy",
      "Other",
    ],
    "Pharm.D": ["Pharm.D", "Other"],
    "B.Sc": [
      "Forensic Science",
      "Cyber Security & Digital Forensics",
      "Real Estate Valuation",
      "Data Science",
      "Computer Science",
      "Other",
    ],
    "Others": ["General", "Other"],
  };

  const collegeProgramBranchMap = {
    "Aditya University": {
      "B.Tech": [
        "Agricultural Engineering (Ag.E)",
        "Civil Engineering (CE)",
        "Computer Science and Engineering (CSE)",
        "Artificial Intelligence and Machine Learning (AIML)",
        "Computer Science and Engineering - Data Science (CSE-DS)",
        "Electronics and Communication Engineering (ECE)",
        "Electrical and Electronics Engineering (EEE)",
        "Information Technology (IT)",
        "Mechanical Engineering (ME)",
        "Mining Engineering (Min.E)",
        "Petroleum Technology (PET)",
        "Other",
      ],
      "M.Tech": [
        "Computer Science and Engineering (CSE)",
        "VLSI Design",
        "Energy Science and Technology",
        "Power Electronics and Devices",
        "Structural Engineering",
        "CSE (AI & ML)",
        "Artificial Intelligence and Data Science",
        "Other",
      ],
      "MBA/IMBA": [
        "MBA",
        "MBA (Business Analytics)",
        "MBA (Global Finance)",
        "MBA (FinTech)",
        "MBA (Health Care Management)",
        "MBA for Working Professionals",
        "IMBA (Integrated MBA)",
        "BBA",
        "BBA (Business Analytics)",
        "BBA (Digital Marketing)",
        "Other",
      ],
      "MCA": ["MCA", "Other"],
      "B.Sc": [
        "Forensic Science",
        "Cyber Security & Digital Forensics",
        "Real Estate Valuation",
        "Data Science",
        "Other",
      ],
      "B.Pharmacy": ["B.Pharmacy", "Other"],
      "M.Pharmacy": [
        "Pharmaceutics",
        "Pharmaceutical Analysis",
        "Pharmacology",
        "Regulatory Affairs",
        "Other",
      ],
      "Pharm.D": ["Pharm.D", "Pharm.D (Post Baccalaureate)", "Other"],
      "Ph.D": [
        "Computer Science and Engineering",
        "Electronics and Communication Engineering",
        "Electrical and Electronics Engineering",
        "Mechanical Engineering",
        "Civil Engineering",
        "Agricultural Engineering",
        "Mining Engineering",
        "Petroleum Technology",
        "Management Studies",
        "Mathematics",
        "Physics",
        "Chemistry",
        "English",
        "Pharmaceutical Sciences",
        "Other",
      ],
      "Diploma": [
        "Civil Engineering (CE)",
        "Computer Science and Engineering (CSE)",
        "Communication & Computer Networking",
        "Electronics and Communication Engineering (ECE)",
        "Electrical and Electronics Engineering (EEE)",
        "Mechanical Engineering (ME)",
        "Mining Engineering (Min.E)",
        "Petroleum Technology (PET)",
        "Other",
      ],
    },
    "Aditya Engineering College (Campus - 1)": {
      "B.Tech": [
        "CSE",
        "ECE",
        "EEE",
        "DS & IT",
        "CE",
        "MEC",
        "AIML",
        "Ag.E",
        "Min.E",
        "PET",
        "Other",
      ],
      "M.Tech": [
        "Computer Science and Engineering (CSE)",
        "VLSI Design",
        "Power Electronics and Drives",
        "Structural Engineering",
        "Thermal Engineering",
        "CSE (AI & ML)",
        "Petroleum Engineering",
        "Other",
      ],
      "MCA": ["MCA", "Other"],
      "MBA/IMBA": ["MBA", "IMBA", "Other"],
      "Diploma": [
        "Civil Engineering (CE)",
        "Electrical and Electronics Engineering (EEE)",
        "Mechanical Engineering (ME)",
        "Electronics and Communication Engineering (ECE)",
        "Computer Science and Engineering (CSE)",
        "Mining Engineering (Min.E)",
        "Petroleum Technology (PET)",
        "Other",
      ],
      "Ph.D": [
        "Computer Science and Engineering",
        "Electronics and Communication Engineering",
        "Electrical and Electronics Engineering",
        "Mechanical Engineering",
        "Civil Engineering",
        "Petroleum Technology",
        "Mining Engineering",
        "Other",
      ],
    },
    "Aditya College of Engineering and Technology (Campus - 2)": {
      "B.Tech": [
        "CSE",
        "ECE",
        "EEE",
        "CE",
        "MEC",
        "AIML & DS",
        "IT",
        "Other",
      ],
      "M.Tech": [
        "Computer Science and Engineering (CSE)",
        "Embedded Systems",
        "Power Electronics",
        "Structural Engineering",
        "Thermal Engineering",
        "Other",
      ],
      "MCA": ["MCA", "Other"],
      "MBA/IMBA": ["MBA", "Other"],
      "Diploma": [
        "Civil Engineering (CE)",
        "Electrical and Electronics Engineering (EEE)",
        "Mechanical Engineering (ME)",
        "Electronics and Communication Engineering (ECE)",
        "Computer Science and Engineering (CSE)",
        "Other",
      ],
    },
    "Aditya College Of Engineering (Campus - 3)": {
      "B.Tech": [
        "CSE",
        "ECE",
        "EEE",
        "IoT",
        "CE",
        "MEC",
        "AIML",
        "Other",
      ],
      "M.Tech": [
        "Computer Science and Engineering (CSE)",
        "VLSI Design",
        "Power Electronics and Drives",
        "Embedded Systems",
        "Other",
      ],
      "MBA/IMBA": ["MBA", "Other"],
      "Diploma": [
        "Civil Engineering (CE)",
        "Electrical and Electronics Engineering (EEE)",
        "Mechanical Engineering (ME)",
        "Electronics and Communication Engineering (ECE)",
        "Computer Science and Engineering (CSE)",
        "Other",
      ],
    },
    "Aditya Polytechnic Colleges": {
      "Diploma": [
        "Civil Engineering (CE)",
        "Electrical and Electronics Engineering (EEE)",
        "Mechanical Engineering (ME)",
        "Electronics and Communication Engineering (ECE)",
        "Computer Science and Engineering (CSE)",
        "Petroleum Technology (PET)",
        "Mining Engineering (Min.E)",
        "Communication & Computer Networking",
        "Other",
      ],
    },
    "Aditya Pharmacy Colleges": {
      "B.Pharmacy": ["B.Pharmacy", "Other"],
      "M.Pharmacy": [
        "Pharmaceutics",
        "Pharmaceutical Analysis",
        "Pharmacology",
        "Regulatory Affairs",
        "Pharmacognosy",
        "Other",
      ],
      "Pharm.D": ["Pharm.D", "Pharm.D (Post Baccalaureate)", "Other"],
      "Diploma": ["D.Pharmacy", "Other"],
      "Ph.D": ["Pharmaceutical Sciences", "Other"],
    },
    "Aditya Business Schools": {
      "MBA/IMBA": [
        "MBA",
        "MBA (Business Analytics)",
        "MBA (Finance)",
        "MBA (Human Resource Management)",
        "MBA (Marketing)",
        "MBA (Digital Marketing)",
        "MBA (Health Care Management)",
        "IMBA (Integrated MBA)",
        "BBA",
        "BBA (Business Analytics)",
        "BBA (Digital Marketing)",
        "Other",
      ],
      "Ph.D": ["Management Studies", "Other"],
    },
  };

  const programs = [
    "Diploma",
    "B.Tech",
    "M.Tech",
    "MBA/IMBA",
    "MCA",
    "Ph.D",
    "B.Pharmacy",
    "M.Pharmacy",
    "Pharm.D",
    "B.Sc",
    "Others",
  ];

  const port = process.env.REACT_APP_BACKEND_URL;

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    collegeName: "",
    branch: "",
    programName: "",
    graduationYear: "",
    rollNumber: "",
    company: "",
    designation: "",
    email: "",
    linkedin: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...((name === "collegeName" || name === "programName") && { branch: "" }), // reset branch
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
      ...((name === "collegeName" || name === "programName") && { branch: "" }),
    }));
  };

  const getBranches = () => {
    if (!formData.collegeName || !formData.programName) {
      return [];
    }
    const collegeMap = collegeProgramBranchMap[formData.collegeName];
    if (collegeMap && collegeMap[formData.programName]) {
      return collegeMap[formData.programName];
    }
    if (defaultProgramBranches[formData.programName]) {
      return defaultProgramBranches[formData.programName];
    }
    return ["General", "Other"];
  };

  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    // Phone
    const phoneRegex = /^[0-9]{10}$/;
    if (formData.phone && !phoneRegex.test(formData.phone)) {
      newErrors.phone = "Enter valid 10 digit number";
    }

    // Graduation Year
    const currentYear = new Date().getFullYear();
    if (!formData.graduationYear) {
      newErrors.graduationYear = "Graduation year required";
    } else if (
      formData.graduationYear < 1950 ||
      formData.graduationYear > currentYear
    ) {
      newErrors.graduationYear = "Enter valid graduation year";
    }

    // LinkedIn
    if (formData.linkedin) {
      const linkedinRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/.+$/;
      if (!linkedinRegex.test(formData.linkedin)) {
        newErrors.linkedin = "Enter valid LinkedIn URL";
      }
    }

    // Required fields
    if (!formData.collegeName) newErrors.collegeName = "College required";
    if (!formData.programName) newErrors.programName = "Program name is required";
    if (!formData.branch) newErrors.branch = "Branch required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      await axios.post(`${port}/alumni/create`, formData);

      setSuccess("Form submitted successfully");

      setFormData({
        name: "",
        address: "",
        phone: "",
        collegeName: "",
        branch: "",
        programName: "",
        graduationYear: "",
        rollNumber: "",
        company: "",
        designation: "",
        email: "",
        linkedin: "",
      });
      setOpenSnackbar(true);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      console.error(error);
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong. Please try again.");
      }
      setSuccess("");
    }

    setLoading(false);
  };

  return (
    <main className="site_main alumni_reg_page">
      <section className="departover_sec contactpage_sec">
        <div className="container">
          {/* Page Title */}
          <div className="inner_title alumni_inner_title">
            <h1 className="title42">Alumni Registration</h1>
          </div>

          <div className="event_form_container">
            <div className="ctnform">
              {success && (
                <Alert severity="success" sx={{ mb: 3 }}>
                  {success}
                </Alert>
              )}

              <form onSubmit={handleSubmit} id="registrationForm">
                {/* ── 1. PERSONAL INFORMATION ── */}
                <div className="form-section-title">
                  <span>Personal Information</span>
                </div>
                <div className="row">
                  {/* Name */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name of the Alumni"
                      />
                      {errors.name && (
                        <div className="field-error">{errors.name}</div>
                      )}
                    </div>
                  </div>

                  {/* Contact Number */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <div
                        className={`phone_field_wrapper ${errors.phone ? "is-invalid" : ""}`}
                      >
                        <div className="phone_dial_code">
                          <span className="flag">
                            <svg
                              width="20"
                              height="14"
                              viewBox="0 0 20 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                borderRadius: "2px",
                                display: "inline-block",
                                verticalAlign: "middle",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <rect width="20" height="4.66" fill="#FF9933" />
                              <rect
                                y="4.66"
                                width="20"
                                height="4.66"
                                fill="#FFFFFF"
                              />
                              <rect
                                y="9.33"
                                width="20"
                                height="4.66"
                                fill="#138808"
                              />
                              <circle
                                cx="10"
                                cy="7"
                                r="1.6"
                                stroke="#000080"
                                strokeWidth="0.5"
                                fill="none"
                              />
                            </svg>
                          </span>
                          <span className="arrow">▼</span>
                          <span className="code">+91</span>
                        </div>
                        <input
                          type="tel"
                          className="form-control"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Contact Number"
                        />
                      </div>
                      {errors.phone && (
                        <div className="field-error">{errors.phone}</div>
                      )}
                    </div>
                  </div>

                  {/* Address – full width */}
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Current City & State"
                      />
                    </div>
                  </div>
                </div>

                {/* ── 2. ACADEMIC INFORMATION ── */}
                <div className="form-section-title">
                  <span>Academic Information</span>
                </div>
                <div className="row">
                  {/* College Name */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <select
                        className={`form-select ${errors.collegeName ? "is-invalid" : ""}`}
                        name="collegeName"
                        value={formData.collegeName}
                        onChange={handleChange}
                      >
                        <option value="">College Name *</option>
                        {colleges.map((college) => (
                          <option key={college} value={college}>
                            {college}
                          </option>
                        ))}
                      </select>
                      {errors.collegeName && (
                        <div className="field-error">{errors.collegeName}</div>
                      )}
                    </div>
                  </div>

                  {/* Name of the Program */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <select
                        className={`form-select ${
                          errors.programName ? "is-invalid" : ""
                        }`}
                        name="programName"
                        value={formData.programName}
                        onChange={handleChange}
                      >
                        <option value="">Name of the Program *</option>

                        {programs.map((program) => (
                          <option key={program} value={program}>
                            {program}
                          </option>
                        ))}
                      </select>

                      {errors.programName && (
                        <div className="field-error">{errors.programName}</div>
                      )}
                    </div>
                  </div>

                  {/* School / Department */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <select
                        className={`form-select ${errors.branch ? "is-invalid" : ""}`}
                        name="branch"
                        value={formData.branch}
                        onChange={handleChange}
                        disabled={!formData.collegeName || !formData.programName}
                      >
                        <option value="">
                          {!formData.collegeName
                            ? "Select College first"
                            : !formData.programName
                            ? "Select Program first"
                            : "Branch / Department *"}
                        </option>
                        {getBranches().map((branch) => (
                          <option key={branch} value={branch}>
                            {branch}
                          </option>
                        ))}
                      </select>
                      {errors.branch && (
                        <div className="field-error">{errors.branch}</div>
                      )}
                    </div>
                  </div>

                  {/* Graduation Year */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="number"
                        className={`form-control ${errors.graduationYear ? "is-invalid" : ""}`}
                        name="graduationYear"
                        value={formData.graduationYear}
                        onChange={handleChange}
                        placeholder="Year of Graduation"
                      />
                      {errors.graduationYear && (
                        <div className="field-error">
                          {errors.graduationYear}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Roll Number */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="rollNumber"
                        value={formData.rollNumber}
                        onChange={handleChange}
                        placeholder="Roll Number"
                      />
                    </div>
                  </div>
                </div>

                {/* ── 3. ORGANISATION & CONTACT ── */}
                <div className="form-section-title">
                  <span>Professional Information</span>
                </div>
                <div className="row">
                  {/* Company */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="Company"
                      />
                    </div>
                  </div>

                  {/* Designation */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                        placeholder="Designation / Role"
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email ID"
                      />
                      {errors.email && (
                        <div className="field-error">{errors.email}</div>
                      )}
                    </div>
                  </div>

                  {/* LinkedIn */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errors.linkedin ? "is-invalid" : ""}`}
                        name="linkedin"
                        value={formData.linkedin}
                        onChange={handleChange}
                        placeholder="LinkedIn Profile"
                      />
                      {errors.linkedin && (
                        <div className="field-error">{errors.linkedin}</div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Actions */}
                <div className="actions-wrapper">
                  <button
                    type="submit"
                    className="apply_btn"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your information has been saved!
        </Alert>
      </Snackbar>
    </main>
  );
}
